import React from "react";
import TempleTimingsInfo from "./TempleTimingsInfo";

function Timing() {
    return (
        <div>
            <div className="row banner" style={{ backgroundImage: 'url(./images/slider-1.jpg)', backgroundSize: 'cover', backgroundPosition: 'center' }}></div>
            
            <div className="container" style={{ backgroundImage: 'url(./images/slider-1.jpg)', marginTop: '100px', marginBottom: '100px', padding: '0px', backgroundSize: 'cover', backgroundAttachment: 'fixed',borderRadius:'25px',boxShadow:'0px 0px 1000px maroon ',display:'flex',justifyContent:'center',alignItems:'center' }}>
                    {/* <TempleTimingsInfo /> */}

                    

<div class="container-" style={{margin:'50px',width:'80%'}}>
{/* <div class="header-">പൂജാ സമയം</div> */}
{/* <!-- Subrahmanya Temple --> */}
<div class="card-1">
<h2 style={{fontFamily:'anek malayalam'}}>ശ്രീ സുബ്രഹ്മണ്യസ്വാമി ക്ഷേത്രം</h2>

<div class="section-title">രാവിലെ</div>
<div class="time-row"><span>നടതുറക്കൽ</span><span>04:00</span></div>
<div class="time-row"><span>അഭിഷേകം</span><span>04:15 - 04:45</span></div>
<div class="time-row"><span>ഉഷപൂജ - ശീവേലി</span><span>05:30 - 06:00</span></div>
<div class="time-row"><span>കലശപൂജ, അഭിഷേകം, ഉച്ചപൂജ, ശീവേലി</span><span>10:30 - 11:15</span></div>
<div class="time-row"><span>നട അടക്കൽ</span><span>12:30</span></div>

<div class="section-title">വൈകുന്നേരം</div>
<div class="time-row"><span>നടതുറക്കൽ</span><span>04:15</span></div>
<div class="time-row"><span>ദീപാരാധന (അസ്തമനത്തിനു മുൻ‍പ്) തിരുവത്താഴ പൂജ, ശീവേലി</span><span>07:20 - 08:00</span></div>
<div class="time-row"><span>നട അടക്കൽ</span><span>08:00</span></div>



<div class="highlight">
സർപ്പബലി, സപരിവാര പൂജ : 05:30 PM<br />
പ്രസാദ വിതരണം : ദീപാരാധനയ്ക്ക് ശേഷം
</div>
</div>

{/* <!-- Ayyappa Temple --> */}
<div class="card-1">
<h2 style={{fontFamily:'anek malayalam'}}>ശ്രീ അയ്യപ്പ ക്ഷേത്രം</h2>

<div class="section-title">രാവിലെ</div>
<div class="time-row"><span>നടതുറക്കൽ</span><span>04:30</span></div>
<div class="time-row"><span>അഭിഷേകം</span><span>04:45 - 05:15</span></div>
<div class="time-row"><span>ഉഷപൂജ</span><span>06:00 - 06:30</span></div>
<div class="time-row"><span>ഉച്ചപൂജ</span><span>10:00 - 11:30</span></div>
<div class="time-row"><span>നട അടക്കൽ</span><span>12:30</span></div>

<div class="section-title">വൈകുന്നേരം</div>
<div class="time-row"><span>നടതുറക്കൽ</span><span>04:30</span></div>
<div class="time-row"><span>ദീപാരാധന (അസ്തമനത്തിനു മുൻ‍പ്) തിരുവത്താഴ പൂജ</span><span>07:00 - 07:30</span></div>
<div class="time-row"><span>നട അടക്കൽ</span><span>07:30</span></div>

</div>

</div>
                

            </div>
        </div>
    );
}

export default Timing;